<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import apiClient from "@/api/api-client";
import HeaderWrapper from "@/components/HeaderWrapper.vue";

export default {
  name: "SummaryReportsList",
  components: { HeaderWrapper, ExportIcon },
  data() {
    return {
      statusTitles: {
        0: "Новые",
        1: "В работе",
        2: "Размеченные",
        3: "На верификации",
        4: "Верифицированные",
      },
      loading: false,
      summaryList: [],
      summaryListTotalCounts: {},
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
    summaryListAllCounts() {
      return [
        {
          created_at: "",
          ...this.summaryListTotalCounts,
        },
      ];
    },
    mergedSummaryList() {
      if (
        !this.summaryListAllCounts ||
        this.summaryListAllCounts.length === 0
      ) {
        return this.summaryList;
      }

      return [
        ...this.summaryList,
        {
          isTotalRow: true,
          ...this.summaryListAllCounts[0],
        },
      ];
    },
    uniqueStatuses() {
      const allStatusKeys = ["0", "1", "2", "3", "4"];
      const statusSet = new Set(allStatusKeys);

      this.summaryList &&
        this.summaryList.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (!isNaN(key)) {
              statusSet.add(key);
            }
          });
        });

      return Array.from(statusSet).sort((a, b) => a - b);
    },
    filteredStatuses() {
      return this.uniqueStatuses.filter((status) =>
        ["0", "1", "2", "3", "4"].includes(status)
      );
    },
  },
  created() {
    this.getSummaryList();
  },
  methods: {
    async getSummaryList() {
      this.loading = true;
      try {
        const response = await apiClient.get("/export/summary");
        if (response && response.data) {
          this.summaryList = response.data.data || [];
          this.summaryListTotalCounts = response.data.all_counts || {};
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadSummaryReport() {
      await this.downloadReport("/export/summary");
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full w-full">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-footer="false"
        :show-filter="false"
        :show-field="true"
      >
        <template #header>
          <div
            class="font-bold truncate flex items-center w-full px-6"
            style="font-size: 17px"
          >
            Сводный
          </div>
        </template>
        <template #field>
          <div class="py-3.5 w-full flex justify-end items-center px-5">
            <el-button
              @click="downloadSummaryReport"
              :disabled="loading"
              type="success"
              plain
            >
              <export-icon></export-icon>
              Скачать xlsx</el-button
            >
          </div>
        </template>
      </HeaderWrapper>
    </div>
    <div class="flex flex-col w-full p-6 flex-1 min-h-0 overflow-hidden">
      <el-table
        :data="mergedSummaryList"
        v-loading="loading"
        border
        stripe
        height="100%"
        style="width: 100%; overflow-y: auto; font-size: 13px"
      >
        <el-table-column label="№" width="55" fixed="left">
          <template #default="{ $index }">
            <span v-if="$index !== mergedSummaryList.length - 1">{{
              $index + 1
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="batch_name"
          label="Имя батча"
          width="250"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="Дата загрузки"
          width="130"
          align="center"
        ></el-table-column>
        <template v-for="status in filteredStatuses" :key="status">
          <el-table-column :label="statusTitles[status]" min-width="160">
            <template #default="{ row }">
              <div v-if="row[status]">
                <div class="flex items-center">
                  Файлы:
                  <div class="font-extrabold text-black ml-1">
                    {{ row[status].count || 0 }}
                  </div>
                </div>
                <div class="flex items-center">
                  Фрагменты:
                  <div class="font-extrabold text-black ml-1">
                    {{ row[status].total_utterances || 0 }}
                  </div>
                </div>
                <div class="flex items-center">
                  "Часов:"
                  <div class="font-extrabold text-black ml-1">
                    {{ (row[status].dur || 0).toFixed(2) }}
                  </div>
                </div>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
</style>
